import axios from 'axios'

const API_ENDPOINT = 'form-submissions'

export default {
    history(params) {
        return axios.get(`${API_ENDPOINT}/history`, {
            params: params
        })
    }
}
